(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './Kermit-kermit-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./Kermit-kermit-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['Kermit-kermit-core'] === 'undefined') {
      throw new Error("Error loading module 'Kermit-kermit'. Its dependency 'Kermit-kermit-core' was not found. Please, check whether 'Kermit-kermit-core' is loaded prior to 'Kermit-kermit'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Kermit-kermit'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kermit-kermit'.");
    }
    globalThis['Kermit-kermit'] = factory(typeof globalThis['Kermit-kermit'] === 'undefined' ? {} : globalThis['Kermit-kermit'], globalThis['Kermit-kermit-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_co_touchlab_kermit_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var platformLogWriter = kotlin_co_touchlab_kermit_core.$_$.d;
  var listOf = kotlin_kotlin.$_$.sa;
  var mutableLoggerConfigInit = kotlin_co_touchlab_kermit_core.$_$.c;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var BaseLogger = kotlin_co_touchlab_kermit_core.$_$.a;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Logger, 'Logger', VOID, BaseLogger);
  initMetadataForCompanion(Companion, Logger);
  //endregion
  function Companion() {
    Companion_instance = this;
    Logger.call(this, mutableLoggerConfigInit(listOf(platformLogWriter())), '');
  }
  protoOf(Companion).c5o = function () {
    return get_defaultTag();
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Logger(config, tag) {
    Companion_getInstance();
    tag = tag === VOID ? '' : tag;
    BaseLogger.call(this, config);
    this.vv9_1 = tag;
  }
  protoOf(Logger).c5o = function () {
    return this.vv9_1;
  };
  function get_defaultTag() {
    return defaultTag;
  }
  var defaultTag;
  //region block: init
  defaultTag = '';
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Logger;
  //endregion
  return _;
}));

//# sourceMappingURL=Kermit-kermit.js.map
